import * as Yup from 'yup';

import isValidDate from '@shared/helpers/isValidDate';
import { calculateAge } from '@shared/helpers/calculateAge';

const REQUIRED_FIELD_MESSAGE = 'Campo requerido';

const PASSENGER_TYPE = {
  ADULT: 1,
  MINOR: 2,
  INFANT: 3,
};

const AGE_VALIDATION_RULES = {
  [PASSENGER_TYPE.ADULT]: {
    isInvalid: age => age <= 17,
    message: 'Debe tener al menos 18 años al inicio del viaje.',
  },
  [PASSENGER_TYPE.MINOR]: {
    isInvalid: age => age > 17,
    message: 'Debe ser menor de 18 años al inicio del viaje.',
  },
  [PASSENGER_TYPE.INFANT]: {
    isInvalid: age => age >= 2,
    message: 'Debe tener menos de 2 años al inicio del viaje.',
  },
};

const isLatin1 = str => {
  if (!str) return true; // null, undefined o '' pasan

  for (let i = 0; i < str.length; i++) {
    const charCode = str.charCodeAt(i);
    if (charCode > 0xff) {
      return false;
    }
  }
  return true;
};

const passengerSchema = search => {
  return Yup.object().shape({
    nombre: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .matches(/^[aA-zZ" "]+$/, 'Caracter inválido'),
    apellido: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .matches(/^[aA-zZ" "]+$/, 'Caracter inválido'),
    numerodedocumento: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .min(7, 'Debe tener un mínimo de 7 caracteres'),
    pais: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    nacionalidad: Yup.string().required(REQUIRED_FIELD_MESSAGE),
    fechadenacimiento: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .test('valid-date', 'Debe elegir una fecha válida', value =>
        isValidDate(value)
      )
      .test('age-check', function (value) {
        if (!value || !search?.checkIn) return true;

        const passengerType = this.parent.passengerType; // 1=adulto,2=menor,3=infante
        const age = calculateAge(value, search.checkIn);
        const rule = AGE_VALIDATION_RULES[passengerType];

        if (rule?.isInvalid(age)) {
          return this.createError({ message: rule.message });
        }

        return true;
      }),
  });
};

export const baseBookingSchema = search => {
  return Yup.object().shape({
    passengers: Yup.array()
      .of(passengerSchema(search))
      .required(REQUIRED_FIELD_MESSAGE),
    email: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .email('Ingrese un email válido'),
    emailValidation: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .email('Ingrese un email válido')
      .oneOf([Yup.ref('email')], 'No coincide con el mail especificado'),
    phone: Yup.string()
      .required(REQUIRED_FIELD_MESSAGE)
      .matches('^[0-9]+$', 'Este campo solo acepta números'),
    comments: Yup.string()
      .max(1000, 'Máximo 1000 caracteres')
      .test(
        'is-latin1',
        '"Información adicional" contiene caracteres no compatibles',
        value => !value || isLatin1(value)
      )
      .nullable(),
    acceptedTerms: Yup.boolean().oneOf([true], 'Debes aceptar los términos'),
  });
};

export default baseBookingSchema;
